import React, { useState } from "react";
import TitleSection from "../title-section";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import "./numberSteps.scss";

const NumberSteps = ({ tituloGeneral, descripcion, referenciaPlantillaContenido, tituloBoton, redireccionBoton}: ReferenciaContenido) => {
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const areThreeSteps = referenciaPlantillaContenido.length === 3;

    return (
        <>
            <div className={`m-number-steps ${areThreeSteps ? "three-steps" : "" }`}>
                {areThreeSteps && (
                    <div className="m-number-steps three-steps__title">
                        <TitleSection title={tituloGeneral} />
                        <p>{documentToReactComponents(descripcion.json)}</p>
                    </div>
                )}
                <div className={"m-number-steps__container"}>
                    {!areThreeSteps && (
                        <div className="m-number-steps__title-container">
                            <TitleSection title={tituloGeneral} />
                            <button className="m-number-steps__button" onClick={() => setIsOpenModal(true)}>{tituloBoton}</button>
                        </div>
                    )}
                    {referenciaPlantillaContenido.map((paso, index) => 
                        <div key={index} className={`m-number-steps__steps ${areThreeSteps && index === 0 ? "m-number-steps__steps__no-border-left" : ""}`}>
                            <img
                                src={paso.imagenPrincipal[0].file.url}
                                alt="Icono primer paso"
                                className="m-number-steps__img"
                            />
                            {paso.tituloBanner &&
                                <h3>{paso.tituloBanner}</h3>
                            }
                            <span className="m-number-steps__text">{paso.tituloDescripcion} <a className="m-number-steps__anchor" href={paso.redireccionBoton} target="_blank">{paso.tituloBoton}</a></span>
                        </div>
                    )}
                </div>
                {areThreeSteps && (
                    <a href={redireccionBoton}><button className="m-number-steps__button">{tituloBoton}</button></a>
                )}
            </div>
            {isOpenModal && (
                <div className="m-number-steps__modal">
                    <span className="icon-close" onClick={() => setIsOpenModal(false)}></span>
                    <div className="m-number-steps__modal-content">
                        <iframe
                            src={redireccionBoton}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
                        </iframe>  
                    </div>
                </div>
            )}
        </>
    );
};

export default NumberSteps;